import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { PasswordErrorMatcher } from '../../../../../modules/shared/validators/password-error-matcher';
import { Component, Directive, EventEmitter, Output } from '@angular/core';

/**
 * Copyright (c) 2010-2022 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
@Component({
    selector: 'dash-gis-base-password-form',
    template: '',
})
export class BasePasswordFormComponent {
    passwordForm: UntypedFormGroup;
    matcher = new PasswordErrorMatcher();

    @Output() formSubmit: EventEmitter<string> = new EventEmitter<string>();
    @Output() formCancel: EventEmitter<void> = new EventEmitter<void>();

    constructor() {}

    getError(controlName: string): string | null {
        if (this.passwordForm.errors) {
            const formErrorKey = Object.keys(this.passwordForm.errors)[0];
            return this.passwordForm.errors[formErrorKey];
        }
        const control = this.passwordForm.get(controlName);
        if (!control) {
            return null;
        }
        if (!control.errors || control.errors.length === 0) {
            return null;
        }
        const errorKey = Object.keys(control.errors)[0];
        const errorObject = control.errors[errorKey];
        switch (errorKey) {
            case 'required':
                return 'This field is required.';
            case 'minlength':
                return `Your password must be at least ${errorObject.requiredLength} characters long.`;
            case 'complexity':
                return 'Your password is not strong enough. See below for hints.';
            case 'mismatch':
                return 'Passwords do not match.';
        }
    }

    matchValidator(group: UntypedFormGroup) {
        const password = group.controls?.newPassword?.value;
        const confirm = group.controls?.newPasswordConfirm?.value;
        return password === confirm ? null : { mismatch: 'Passwords do not match.' };
    }

    submitForm() {
        this.formSubmit.emit(this.passwordForm.value);
    }

    cancelForm() {
        this.formCancel.emit();
    }

    get newPassword(): AbstractControl {
        return this.passwordForm.get('newPassword');
    }

    get newPasswordConfirm(): AbstractControl {
        return this.passwordForm.get('newPasswordConfirm');
    }
}
